import { render, staticRenderFns } from "./FormParametrosEmpresa.vue?vue&type=template&id=12ff4814&"
import script from "./FormParametrosEmpresa.vue?vue&type=script&lang=js&"
export * from "./FormParametrosEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports